import React from "react";
import WorkspaceInternalControls from "../../libraries/WorkspaceInternalControls";

interface LitigationsClaimsInternalControlsProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
  controlsListSection?: string;
}

export default function LitigationsClaimsInternalControls({ onBack, setActiveSection, controlsListSection }: LitigationsClaimsInternalControlsProps) {
  return (
    <WorkspaceInternalControls
      workspaceName="Litigations & Claims"
      onBack={onBack}
      setActiveSection={setActiveSection}
      controlsListSection={controlsListSection}
    />
  );
}
